import { action, makeObservable, observable } from 'mobx'

export type FlashType = 'brand' | 'terciary' | 'correct' | 'wrong' | 'accent'

export interface Flash {
  close?: () => void
  message: string
  type: FlashType
  time?: number
}

export interface Progress {
  message: string
} // FIXME: All those app features should be converted to independent context

class App {
  flash: Flash | null | undefined = null
  progress: Progress | null | undefined
  timeout: ReturnType<typeof setTimeout> | null | undefined = null

  constructor() {
    makeObservable(this, {
      flash: observable,
      progress: observable,
      setFlash: action,
      hideFlash: action,
      setProgress: action,
    })
  }

  setFlash(flash: Flash | null | undefined) {
    // Invalidate previous flashes
    this.timeout && clearTimeout(this.timeout)

    const timeParam = flash && flash.time
    const setTime = timeParam || 5 * 1000
    this.flash = flash
    this.timeout = setTimeout(() => this.hideFlash(), setTime)
  }

  hideFlash() {
    this.flash = null
  }

  setProgress(progress: Progress | null | undefined) {
    this.progress = progress
  }
}

const singleton = new App()

export default singleton
